import { render, staticRenderFns } from "./WLSTableFilterable.vue?vue&type=template&id=470a16e0"
import script from "./WLSTableFilterable.vue?vue&type=script&lang=ts"
export * from "./WLSTableFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports